'use client'
import * as React from 'react'
import { NewsletterPopup } from 'components/popups/newsletter'

import { useSitePopup } from '../../hooks/use-site-data'
import { ProfileNudgePopup } from './profile-nudge'
import { NotificationPopup } from './notification-popup'

export function SitewidePopup() {
  const popup = useSitePopup()

  if (popup?.__typename === 'NewsletterPopup') {
    return <NewsletterPopup popup={popup} />
  }

  if (popup?.__typename === 'ProfileNudgePopup') {
    return <ProfileNudgePopup popup={popup} />
  }

  if (popup?.__typename === 'NotificationPopup') {
    return <NotificationPopup popup={popup} />
  }

  return null
}
